export const BASE_POLICY_TEMPLATE = {
  DefaultWindows: 'DefaultWindows',
  AllowMicrosoft: 'AllowMicrosoft',
};

const BASE_POLICY_TEMPLATE_MAPPING = [
  {
    value: BASE_POLICY_TEMPLATE.DefaultWindows,
    label: 'Default Windows',
    description: 'Windows, drivers, Store apps and Microsoft product roots. Recommended.',
  },
  {
    value: BASE_POLICY_TEMPLATE.AllowMicrosoft,
    label: 'Allow Microsoft',
    description:
      'Everything signed by a Microsoft root, including Office and other Microsoft tools.',
  },
];

export const getBasePolicyTemplateLabel = value =>
  BASE_POLICY_TEMPLATE_MAPPING.find(item => item.value === value)?.label ?? '';

export const getBasePolicyTemplateOptions = () =>
  BASE_POLICY_TEMPLATE_MAPPING.map(item => ({ ...item }));
